export class PageConfig {
  public defaults: any = {
    dashboard: {
      page: {
        title: "Inicio / Home",
        desc: "",
      },
    },
    parametros: {
      page: {
        title: "Parámetros / Settings",
        desc: "",
      },
    },
    aseguradora: {
      page: {
        title: "Aseguradora / Insurance Company",
        desc: "",
      },
      crear: {
        page: {
          title: "Crear Asegúradora / Add Insurance Company",
          desc: {
            title: "Aseguradora",
            link: "/aseguradora",
          },
        },
      },
    },
    intermediario: {
      page: {
        title: "Broker",
        desc: "",
      },
      crear: {
        page: {
          title: "Crear Broker",
          desc: {
            title: "Broker",
            link: "/intermediario",
          },
        },
      },
    },
    usuario: {
      page: {
        title: "Usuario final / Final User",
        desc: "",
      },
      crear: {
        page: {
          title: "Crear usuario final / Add Final User",
          desc: {
            title: "Usuario final",
            link: "/usuario",
          },
        },
      },
    },
    poliza: {
      page: {
        title: "Póliza madre / Mother Policy",
        desc: "",
      },
      crear: {
        page: {
          title: "Crear póliza madre / Add Mother Policy",
          desc: {
            title: "Póliza madre / Mother Policy",
            link: "/poliza",
          },
        },
      },
    },
    vencer: {
      page: {
        title: "Pólizas próximas a vencer / Next to Expire Policies",
        desc: "",
      },
    },
    generadores: {
      page: {
        title: "Generadores / Insured",
        desc: "",
      },
    },
    despacho: {
      page: {
        title: "Asegurar despacho / Get a Certificate",
        desc: "",
      },
    },
    reportes: {
      page: {
        title: "Reportes / Reports",
        desc: "",
      },
    },
    borradores: {
      page: {
        title: "Cotizaciones / Quote slips",
        desc: "",
      },
    },
    consolidado: {
      page: {
        title: "Reporte Despacho Consolidado / Consolidated Dispatch Report ",
        desc: "",
      },
    },
    detalle: {
      page: {
        title: "Detalle despachos / Dispatch Detail",
        desc: "",
      },
    },
    "reporte-aseguradora": {
      page: {
        title: "Reporte Aseguradora / Insurer Report",
        desc: "",
      },
    },
  };

  public get configs(): any {
    return this.defaults;
  }
}
